import {RowUnit} from "../../../../library/atomic/unit/RowUnit";
import {SpanText} from "../../../../library/atomic/text/SpanText";
import {SizeAttr} from "../../../../library/basic/size";
import {RowAttr} from "../../../../library/basic/compose";
import {Button, Input, Select} from "antd";
import {WindowParam} from "../../../../library/context/WindowContext";
import {ColumnUnit} from "../../../../library/atomic/unit/ColumnUnit";
import {MinusCircleOutlined} from "@ant-design/icons";
import {BoxUnit} from "../../../../library/atomic/unit/BoxUnit";
import TextArea from "antd/es/input/TextArea";

export function ModifyInputString(wp: WindowParam, desc: string, value: string, setValue: (v: string) => void,
                                  placeholder: string = "", width: string = "660px", height: string = "36px",
                                  innerDescWidth: string = "100px", outerMarginBottom: string = "22px", inputType: string = "text",
                                  disabled: boolean = false) {
    return (
        <RowUnit
            customStyleAttr={{
                "marginBottom": outerMarginBottom
            }}
            sizeAttr={new SizeAttr(wp, width, height)}>
            <SpanText
                sizeAttr={new SizeAttr(wp, innerDescWidth)}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {"justifyContent": ""})}>
                {desc}
            </SpanText>
            <Input
                type={inputType}
                disabled={disabled}
                defaultValue={""}
                style={Object.assign(RowAttr.getChildrenPositionObj(), {
                    "width": SizeAttr.pxMinus(width, innerDescWidth),
                    "color": disabled ? "black" : ""
                })}
                value={value}
                onChange={(e) => {
                    let v = e.target.value
                    setValue(v)
                }}
                placeholder={placeholder}
            />
        </RowUnit>
    )
}

export function ModifyInputTextArea(wp: WindowParam, desc: string, value: string, setValue: (v: string) => void,
                                    placeholder: string = "", width: string = "660px", height: string = "36px",
                                    innerDescWidth: string = "100px", outerMarginBottom: string = "22px", inputType: string = "text",
                                    disabled: boolean = false) {
    return (
        <RowUnit
            customStyleAttr={{
                "marginBottom": outerMarginBottom
            }}
            sizeAttr={new SizeAttr(wp, width)}>
            <SpanText
                sizeAttr={new SizeAttr(wp, innerDescWidth)}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {"justifyContent": ""})}>
                {desc}
            </SpanText>
            <TextArea
                rows={12}
                disabled={disabled}
                style={Object.assign(RowAttr.getChildrenPositionObj(), {
                    "width": SizeAttr.pxMinus(width, innerDescWidth),
                    "color": disabled ? "black" : ""
                })}
                value={value}
                onChange={(e) => {
                    let v = e.target.value
                    setValue(v)
                }}
                placeholder={placeholder}
            />
        </RowUnit>
    )
}

export function ModifyInputSelect(wp: WindowParam, desc: string, value: string, setValue: (v: string) => void,
                                  options: { value: string, label: string }[],
                                  width: string = "660px", height: string = "36px",
                                  innerDescWidth: string = "100px", outerMarginBottom: string = "22px",
                                  disabled: boolean = false) {
    return (
        <RowUnit
            customStyleAttr={{
                "marginBottom": outerMarginBottom
            }}
            sizeAttr={new SizeAttr(wp, width, height)}>
            <SpanText
                sizeAttr={new SizeAttr(wp, innerDescWidth)}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {"justifyContent": ""})}>
                {desc}
            </SpanText>
            <Select
                disabled={disabled}
                defaultValue={value}
                value={value}
                style={Object.assign(RowAttr.getChildrenPositionObj(), {
                    "width": SizeAttr.pxMinus(width, innerDescWidth),
                    "color": disabled ? "black" : ""
                })}
                onChange={(e) => {
                    setValue(e)
                }}
                options={options}
            />
        </RowUnit>
    )
}

export function ModifyInputTags(wp: WindowParam, desc: string, value: string, setValue: (v: string) => void,
                                width: string = "660px", height: string = "36px",
                                innerDescWidth: string = "100px", outerMarginBottom: string = "22px",
                                iconMargin: string = "22px", iconSize: string = "22px", disabled: boolean = false
) {
    let tagArr = [""]
    try {
        tagArr = JSON.parse(value) as string[]
        if (tagArr.length == 0) {
            tagArr = [""]
        }
    } catch (e) {
        console.log(e)
    }

    let totalWidth = SizeAttr.pxPlus(width, SizeAttr.pxPlus(iconMargin, iconSize))
    let outerColWidth = SizeAttr.pxMinus(totalWidth, innerDescWidth)
    let inputWidth = SizeAttr.pxMinus(width, innerDescWidth)

    return (
        <RowUnit
            customStyleAttr={{
                "marginBottom": outerMarginBottom
            }}
            sizeAttr={new SizeAttr(wp, totalWidth)}>
            <ColumnUnit
                sizeAttr={new SizeAttr(wp, innerDescWidth, height)}>
                <SpanText
                    sizeAttr={new SizeAttr(wp, innerDescWidth)}
                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {"justifyContent": ""})}>
                    {desc}
                </SpanText>
            </ColumnUnit>
            <ColumnUnit
                sizeAttr={new SizeAttr(wp, outerColWidth)}>
                {
                    tagArr.map((t, i) => {
                        return (
                            <RowUnit
                                customStyleAttr={{"marginBottom": outerMarginBottom}}
                                sizeAttr={new SizeAttr(wp, outerColWidth, height)}>
                                <Input
                                    disabled={disabled}
                                    style={Object.assign(RowAttr.getChildrenPositionObj(), {
                                        "width": inputWidth,
                                        "color": disabled ? "black" : ""
                                    })}
                                    value={t}
                                    onChange={(e) => {
                                        let v = e.target.value
                                        let newTagArr = tagArr
                                        newTagArr[i] = v
                                        setValue(JSON.stringify(newTagArr))
                                    }}
                                    placeholder={""}
                                />
                                {
                                    !disabled && i != 0 &&
                                    <BoxUnit
                                        customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                            "marginLeft": iconMargin
                                        })}
                                        onClick={() => {
                                            let newTagArr = tagArr
                                            newTagArr.splice(i, 1)
                                            setValue(JSON.stringify(newTagArr))
                                        }}
                                        sizeAttr={new SizeAttr(wp, iconSize, iconSize)}
                                        needHover={true}
                                    >
                                        <MinusCircleOutlined
                                            size={SizeAttr.getPxNumber(iconSize)}
                                        />
                                    </BoxUnit>
                                }
                            </RowUnit>
                        )
                    })
                }
                {
                    !disabled &&
                    <Button
                        style={{width: 120}}
                        color={"primary"}
                        variant={"dashed"}
                        onClick={() => {
                            let newTagArr = tagArr
                            newTagArr.push("")
                            setValue(JSON.stringify(newTagArr))
                        }}
                    >
                        {"新增标签"}
                    </Button>
                }
            </ColumnUnit>
        </RowUnit>
    )
}